import { Box, Input, InputGroup, InputRightAddon, useToast, VStack } from '@chakra-ui/react';
import { useWSysHub, useWSysPage } from "@coimbra-its/websys-ux-core";
import { useEffect, useState } from 'react';
import { SunBlock, SunButton, SunPage, SunStack, SunValue, dispYearMonth, extractReadableError, formatAmount } from "../components/Sun";
import { SunState, useSunStore } from '../store/sunSlice';
import { payout_address_sdbn3 } from '../web3/config';


export function PayoutSDBN3() {
    const page = useWSysPage({ title: 'Payout SDBN3', maxCols: 2 });

    const hub = useWSysHub();

    const connectedWallet = useSunStore((state: SunState) => state.connectedWallet);
    const loadBalance = useSunStore((state: SunState) => state.loadBalance);
    const USDTBalance = useSunStore((state: SunState) => state.walletAmounts.USDTBalance);
    //const USDTApprovedLimit = useSunStore((state: SunState) => state.walletAmounts.USDTApprovedLimit); ?? itt inkább a payout_ -ra vett allowance kéne
    const [approvedAmount, setApprovedAmount] = useState(0)

    const [lastDate, setLastDate] = useState(0);
    const [lastDatePaid, setLastDatePaid] = useState(false);
    const [nextDate, setNextDate] = useState(0);
    const [amountStr, setAmountStr] = useState('0');
    const [amount, setAmount] = useState(0);
    useEffect(() => {
        setAmount((parseFloat(amountStr) || 0) * 1e18)
    }, [amountStr]);

    const doLoad = async () => {
        hub.tryCatch(async () => {
            try {

                if (!connectedWallet)
                    throw 'Wallet not connected';

                const _approvedAmount = await connectedWallet.USDTContract.allowance(connectedWallet.address, payout_address_sdbn3);
                setApprovedAmount(_approvedAmount);

                const lastDateEnable = Number(await connectedWallet.PayoutContractSDBN3.lastDate());
                setLastDate(lastDateEnable);

                const paidM = await connectedWallet.PayoutContractSDBN3.paidMonths(BigInt(lastDateEnable));
                setLastDatePaid(paidM);

                if (!paidM) {
                    setNextDate(0);
                } else {

                    const lastYear = Math.floor(lastDateEnable / 100);
                    const lastMonth = lastDateEnable - 100 * lastYear;
                    let nextMonth = lastMonth + 1;
                    let nextYear = lastYear;
                    if (nextMonth > 12) {
                        nextMonth -= 12;
                        nextYear++;
                    }
                    setNextDate(nextYear * 100 + nextMonth);
                }

            } catch (ex) {
                throw extractReadableError(ex);
            }

        })
    }

    useEffect(() => {
        if (connectedWallet)
            doLoad();
    }, [connectedWallet])


    const doApprove = async () => {
        hub.tryCatch(async () => {
            try {

                if (!connectedWallet)
                    throw 'Wallet not connected';

                let value = BigInt(amount);

                // Végrehajtjuk az approve metódust
                const tx = await connectedWallet.USDTContract.approve(payout_address_sdbn3, value);

                // Várunk a tranzakció megerősítésére
                const receipt = await tx.wait();

                // Tranzakció hash kiírása
                console.log('Transaction hash:', receipt.hash);

                await loadBalance();
            } catch (ex) {
                throw extractReadableError(ex);
            }
        });

    }

    const doPayout = async () => {
        hub.tryCatch(async () => {
            try {

                if (!connectedWallet)
                    throw 'Wallet not connected';

                if (!nextDate || amount < 0)
                    return;

                // Végrehajtjuk az approve metódust
                const tx = await connectedWallet.PayoutContractSDBN3.addDateAndAmount(BigInt(nextDate), BigInt(amount));

                // Várunk a tranzakció megerősítésére
                const receipt = await tx.wait();

                // Tranzakció hash kiírása
                console.log('Transaction hash:', receipt.hash);

                await loadBalance();
                await doLoad();
            } catch (ex) {
                throw extractReadableError(ex);
            }
        });

    }


    const doSync = async () => {
        hub.tryCatch(async () => {
            try {

                if (!connectedWallet)
                    throw 'Wallet not connected';

                let tx = await connectedWallet.PayoutContractSDBN3.syncBalances();
                const receipt = await tx.wait();

                // Tranzakció hash kiírása
                console.log('Transaction hash:', receipt.hash);

                await loadBalance();
                await doLoad();
            } catch (ex) {
                throw extractReadableError(ex);
            }

        });

    }

    const toast = useToast();
    const doSyncNew = async () => {
        hub.tryCatch(async () => {
            try {

                const resp = await fetch("https://token.sdbn3.com:25003/api/sdbn3/sync_balances", { method: 'POST' })
                const response = await resp.json();
                if (response.publicMessage)
                    throw response.publicMessage;
                else if (!resp.ok)
                    throw 'Failed to fetch'



                await loadBalance();
                await doLoad();
                toast({ status: 'success', description: 'Synchronization success' });
            } catch (ex) {
                throw extractReadableError(ex);
            }
        });

    }



    return <SunPage page={page} hubs={[hub]}>

        <SunStack>
            {connectedWallet && <>
                <SunBlock header='Last date'>
                    <SunValue dim={lastDatePaid ? 'Paid' : 'Not paid'}>
                        {dispYearMonth(lastDate)}
                    </SunValue>
                </SunBlock>
                <SunBlock header='Next date'>
                    <SunValue>
                        {nextDate
                            ? dispYearMonth(nextDate)
                            : 'Last date is not ready!'
                        }
                    </SunValue>
                </SunBlock>
                <SunBlock header='Your balance'>
                    <SunValue dim='USDT'>{formatAmount(USDTBalance)}</SunValue>
                </SunBlock>
                <SunBlock header='Payout amount' py={3}>
                    <InputGroup>
                        <Input
                            value={amountStr} onChange={e => setAmountStr(e.target.value)}
                            border='none' textAlign='right'
                        />
                        <InputRightAddon>USDT</InputRightAddon>
                    </InputGroup>
                </SunBlock>

                <SunBlock display='flex' flexDir='row' justifyContent='space-evenly' alignItems='center' py={3}>
                    <SunButton
                        isDisabled={!lastDatePaid || amount <= 0}
                        onClick={doPayout}>
                        Pay
                    </SunButton>
                </SunBlock>

                <SunBlock py={3} flexDir='column'>
                    <Box p={3} textAlign='center'>
                        {lastDatePaid
                            ? `Last date (${dispYearMonth(lastDate)}) is synchronized`
                            : `Last date (${dispYearMonth(lastDate)}) is NOT synchronized`
                        }
                    </Box>
                    <SunButton onClick={doSyncNew} isDisabled={lastDatePaid} >Synchronize</SunButton>
                </SunBlock>


            </>}
        </SunStack>

    </SunPage>
}